import { motion } from "framer-motion";
import { Zap, Puzzle, Salad, Globe, ConciergeBell, Smartphone } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const CARDS = [
  { icon: Zap, t: "why1t", d: "why1d" },
  { icon: Puzzle, t: "why2t", d: "why2d" },
  { icon: Salad, t: "why3t", d: "why3d" },
  { icon: Globe, t: "why4t", d: "why4d" },
  { icon: ConciergeBell, t: "why5t", d: "why5d" },
  { icon: Smartphone, t: "why6t", d: "why6d" },
];

export function ValueCards() {
  const { t } = useLang();
  return (
    <section data-testid="value-cards">
      <h2 className="mb-3 px-4 font-heading text-lg font-extrabold">{t("whyTitle")}</h2>
      <div className="no-scrollbar flex gap-3 overflow-x-auto px-4 pb-1">
        {CARDS.map((c, i) => {
          const Icon = c.icon;
          return (
            <motion.div
              key={c.t}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: Math.min(i * 0.05, 0.3) }}
              className="w-56 shrink-0 rounded-2xl border border-border bg-card p-4 shadow-soft"
            >
              <span className="mb-3 grid h-10 w-10 place-items-center rounded-xl bg-primary/10 text-primary">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="font-heading text-[15px] font-bold">{t(c.t)}</h3>
              <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{t(c.d)}</p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
